export const ADD_HOSPITAL_TO_COMPARE = "ADD_HOSPITAL_TO_COMPARE";
export const REMOVE_HOSPITAL_FROM_COMPARE = "REMOVE_HOSPITAL_FROM_COMPARE";
export const CLEAR_HOSPITALS_COMPARE = "CLEAR_HOSPITALS_COMPARE";
export const UPDATE_HOSPITAL_IN_COMPARE = 'UPDATE_HOSPITAL_IN_COMPARE';
export const ADD_NEW_HOSPITAL = "ADD_NEW_HOSPITAL";
export const REMOVE_EMPTY_HOSPITALS = "REMOVE_EMPTY_HOSPITALS";